import React from 'react';
import '../AlertDetails.scss';
import Label from 'components/form/Label/Label';
import classnames from 'classnames';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { toSentenceCase } from 'helpers/alerts.helpers';

const AlertDetailsListRow = ({ datatestid, title, value, source }) => {
  return (
    <div className="alertListRow">
      <Label
        type="caption"
        datatestid={`${datatestid}-${title}-title`}
        color={`system_neutral_n300_text`}
        className="alertListTitle"
      >
        {toSentenceCase(title)}
      </Label>
      <FlexContainer
        className={classnames('flex-row', {
          'justify-between': source,
          'flex-start': !source,
        })}
      >
        <Label
          datatestid={`${datatestid}-${title}-value`}
          className="alertListValue alertDetailsText system_neutral_n350_text"
        >
          {value}
        </Label>
        {source && (
          <Label type="caption" className="sourceText">
            {source}
          </Label>
        )}
      </FlexContainer>
    </div>
  );
};

const getBorderClass = borderType => {
  return classnames({
    withBorder: borderType,
    borderColorGreen: borderType === 'positive',
    borderColorRed: borderType === 'negative',
    borderColorYellow: borderType === 'neutral',
  });
};

const hasValueToDisplay = list => {
  if (typeof list === 'string' && list.length > 0) {
    return true;
  } else if (Array.isArray(list) && list.length > 0) {
    return list.some(el => el.value);
  }

  return false;
};
const MultiRecordsAlertDetailsList = ({
  datatestid,
  alertDetailsList,
  lineType,
  header,
  ...props
}) => {
  let borderColor = getBorderClass(lineType);
  const firstEl = props.index === 0;
  if (!hasValueToDisplay(alertDetailsList)) {
    //do not show section if there is no value to display
    return <></>;
  }
  return (
    <div
      className="blackMarketAlertsListContainer"
      data-testid={datatestid ? `${datatestid}-blackMarketAlertsList` : null}
    >
      <FlexContainer
        className={classnames(
          'flex-row',
          'detailListHeaderContainer',
          'margB4',
          { ' justify-between showColHead': firstEl, 'flex-start': !firstEl },
        )}
      >
        {header && (
          <Label type="Subtitle-2" className="text-14 margTB16">
            {header}
          </Label>
        )}
      </FlexContainer>

      <div className={`alertsList ${borderColor} margB16`}>
        {alertDetailsList.map((item, index) => {
          if (item.title && item.value) {
            return (
              <AlertDetailsListRow
                key={`${item.title}-${index}`}
                title={item.title}
                value={item.value.val}
                datatestid={datatestid}
              />
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

const IframeAlert = ({ alertDetailsList, iFrameConfig }) => {
  let srcFrame = iFrameConfig?.useAdditionalUrl
    ? iFrameConfig?.alertDetailsList
    : alertDetailsList;
  return (
    <div className="iframeContainer">
      <iframe
        className="cleaniframe"
        src={srcFrame}
        title={'Alert Details'}
        loading={'lazy'}
      >
        <p>Your browser does not support iFrames.</p>
      </iframe>
    </div>
  );
};

const ScoreFactorsItem = ({ factorList, datatestid }) => {
  if (factorList.length > 0) {
    return (
      <div className="scoreFactors">
        <Label
          type="caption"
          datatestid={`${datatestid}-score-factors-title`}
          color={`system_neutral_n300_text`}
          className="alertListTitle margB4"
        >
          Possible causes of your score change
        </Label>
        <div>
          {factorList.map((factor, key) => (
            <div
              key={`score-factor-${key}`}
              className="fontGray400 text-16 m-text-14 factorItem"
            >
              {factor}
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return '';
  }
};

const RegularAlertItem = ({ alertDetailsList, borderColor, datatestid }) => {
  return (
    <div className={`${borderColor} alertsList`}>
      {alertDetailsList.map((item, index) => {
        if (item.title === '__scoreFactors') {
          return (
            <ScoreFactorsItem factorList={item.value} datatestid={datatestid} />
          );
        } else if (item.title && item.value) {
          return (
            <AlertDetailsListRow
              key={`${item.title}-${index}`}
              title={item.title === 'Address' ? 'Creditor address' : item.title}
              value={item.value}
              datatestid={datatestid}
            />
          );
        } else {
          return '';
        }
      })}
    </div>
  );
};

const AlertDetailsList = ({
  datatestid,
  alertDetailsList,
  iFrameConfig,
  lineType,
  header,
  outerClass,
  isFrameAlert,
}) => {
  if (!hasValueToDisplay(alertDetailsList)) {
    //do not show section if there is no value to display
    return <></>;
  }

  const borderColor = getBorderClass(lineType);
  const classNames = classnames('cmAlertsListContainer', {
    pad0: !outerClass && !isFrameAlert,
    [outerClass]: outerClass,
  });

  return (
    <div
      className={classNames}
      datatestid={datatestid ? `${datatestid}-cmAlertsList` : null}
    >
      {header && (
        <FlexContainer className="detailListHeaderContainer">
          <Label className="detailListHeader margB4">{header}</Label>
        </FlexContainer>
      )}

      {isFrameAlert ? (
        <IframeAlert
          alertDetailsList={alertDetailsList}
          iFrameConfig={iFrameConfig}
        />
      ) : (
        <RegularAlertItem
          alertDetailsList={alertDetailsList}
          borderColor={borderColor}
          datatestid={datatestid}
        />
      )}
    </div>
  );
};

export { AlertDetailsList, MultiRecordsAlertDetailsList };
